export default "__VITE_ASSET__D2Eafxs2__"